import { render } from "./DisplayCompositeCollection.vue?vue&type=template&id=3641aa96"
import script from "./DisplayCompositeCollection.vue?vue&type=script&lang=js"
export * from "./DisplayCompositeCollection.vue?vue&type=script&lang=js"

import "./DisplayCompositeCollection.vue?vue&type=style&index=0&id=3641aa96&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__